import './index.css';
import { StrictMode } from 'react';
import { BrowserRouter } from 'react-router-dom';
import { createRoot } from 'react-dom/client';
import { Provider } from 'mobx-react';

import accountsStore from 'stores/accountsStore';
import authStore from 'stores/authStore';
import balancesStore from 'stores/balancesStore';
import cardsStore from 'stores/cardsStore';
import counterpartiesStore from 'stores/counterpartiesStore';
import commissionTransactionsStore from 'stores/commissionTransactionsStore';
import converaStatementsStore from 'stores/converaStatementsStore';
import customersStore from 'stores/customersStore';
import emailStatisticsStore from 'stores/emailStatisticsStore';
import exchangeTransactionsStore from 'stores/exchangeTransactionsStore';
import limitsStore from 'stores/limitsStore';
import markupsStore from 'stores/markupsStore';
import messagesStore from 'stores/messagesStore';
import paymentObligationsStore from 'stores/paymentObligationsStore';
import settingsStore from 'stores/settingsStore';
import integrationSettingsStore from 'stores/integrationSettingsStore';
import reconciliationReportsStore from 'stores/reconciliationReportsStore';
import tariffsStore from 'stores/tariffsStore';
import transactionsStore from 'stores/transactionsStore';
import transitTransactionsStore from 'stores/transitTransactionsStore';
import usersStore from 'stores/usersStore';
import emailValidationRulesStore from 'stores/emailValidationRulesStore';
import operatorsStore from 'stores/operatorsStore';
import ApplicationProvider from 'contexts/ApplicationContext';

import App from './App';
import 'assets/fonts/Manrope-Regular.ttf';
import 'assets/fonts/Manrope-SemiBold.ttf';
import 'bootstrap/dist/css/bootstrap.css';
import 'styles.scss';

const stores = {
  accountsStore,
  authStore,
  balancesStore,
  cardsStore,
  counterpartiesStore,
  commissionTransactionsStore,
  converaStatementsStore,
  customersStore,
  emailStatisticsStore,
  exchangeTransactionsStore,
  limitsStore,
  markupsStore,
  messagesStore,
  paymentObligationsStore,
  settingsStore,
  integrationSettingsStore,
  reconciliationReportsStore,
  tariffsStore,
  transactionsStore,
  transitTransactionsStore,
  usersStore,
  emailValidationRulesStore,
  operatorsStore
};

const root = createRoot(document.getElementById('root'));
root.render(
  <StrictMode>
    <Provider {...stores}>
      <ApplicationProvider>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </ApplicationProvider>
    </Provider>
  </StrictMode>
);
